import Markdoc, { Config } from "@markdoc/markdoc";
import { DataSourceInputType } from "../../helper/dataSource/DataSourceInputType";
import { DataSourceInstructionVariables } from "../../helper/dataSource/getDataSourceInstructions";

export const instructionHeading = {
  selfClosing: true,
  transform(_node, config: Config) {
    const variables = config.variables as DataSourceInstructionVariables;

    const dataSourceName = variables.dataSourceName ?? "";
    const importMethod = variables.importMethod;

    switch (importMethod) {
      case DataSourceInputType.Api:
        return new Markdoc.Tag("h2", {}, [
          `How to sync your ${dataSourceName} transactions`,
        ]);

      case DataSourceInputType.Csv:
        return new Markdoc.Tag("h2", {}, [
          `How to import your ${dataSourceName} transactions`,
        ]);

      default:
        return new Markdoc.Tag("h2", {}, ["How to import your transactions"]);
    }
  },
};
